import PropTypes from 'prop-types';
import React, { Component } from 'react';
import createClient from '../../../connections/client';
import { UX2 } from '@wsb/guac-widget-core';
import dataAids from '../../../common/dataAids';
import { validateWithChanges, WithError } from '../../../common/validation';
import { getQueryStringValue } from '../../../common/helpers';
import Styles from '../../../common/StackedFormStyles';
import { validate } from './validation';

const styles = new Styles();

class ResetPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);

    const passwordExpiresAt = Number(getQueryStringValue('x'));
    const codeExpired = passwordExpiresAt > 0 && new Date(passwordExpiresAt * 1000) <= new Date();
    const errorCode = getQueryStringValue('err');

    this.state = {
      password: '',
      confirmPassword: '',
      email: decodeURIComponent(getQueryStringValue('e')),
      token: getQueryStringValue('t'),
      contactId: getQueryStringValue('id'),
      redirect: unescape(getQueryStringValue('r')),
      app: unescape(getQueryStringValue('app')) || 'website',
      hasErrors: !!errorCode,
      errors: errorCode ? { form: 'resetErrorMessage' } : {},
      busy: false,
      codeExpired
    };

    if (codeExpired) this.resendPasswordReset();
  }

  resendPasswordReset() {
    const { ventureId } = this.props;
    const { email, redirect } = this.state;

    const ravenClient = createClient({ baseUrl: `/m/api/crm` });
    ravenClient.requestPasswordReset({ ventureId, email, redirect, source: 'WEBSITE_BUILDER' });
  }

  onChange({ target }) {
    const { name, value } = target;
    this.setState({ [name]: value });
  }

  onSubmit(e) {
    this.setState({ busy: true });

    const validatedStated = validateWithChanges(validate)(this.state);
    const { hasErrors } = validatedStated;

    if (hasErrors) {
      e.preventDefault();
      this.setState(validatedStated);
      return false;
    }
  }

  render() {
    const { Heading, Container, Block, Text, Input, Button, Error } = UX2.Element;
    const { staticContent } = this.props;
    const { password, confirmPassword, email, busy, codeExpired, contactId, token, redirect, app } =
      this.state;
    const {
      Grid,
      Grid: { Cell }
    } = UX2.Component;

    return (
      <Container>
        <Heading
          style={ styles.marginBottom }
          data-aid={ dataAids.MEMBERSHIP_PASS_RESET_TITLE_REND }
          level={ 2 }
        >
          { staticContent.resetPasswordTitle }
        </Heading>
        <Grid inset>
          <Cell>
            { codeExpired || (
              <React.Fragment>
                <Text
                  data-aid={ dataAids.MEMBERSHIP_PASS_RESET_MESSAGE_REND }
                  style={ styles.centeredMarginBottom }
                >
                  { `${staticContent.resetPasswordMessage} ${email}.` }
                </Text>
                <UX2.Group.Form
                  tag='form'
                  onSubmit={ this.onSubmit }
                  action='/m/reset'
                  method='post'
                  data-aid={ dataAids.MEMBERSHIP_PASS_RESET_FORM_REND }
                  style={{ ...styles.flexContainer, ...styles.formContainer }}
                >
                  <Block style={ styles.marginBottom }>
                    <Input
                      tag='input'
                      type='password'
                      name='password'
                      onChange={ this.onChange }
                      placeholder={ staticContent.passwordPlaceholder }
                      aria-label={ staticContent.passwordPlaceholder }
                      data-aid={ dataAids.MEMBERSHIP_PASS_RESET_PASS }
                      value={ password }
                    />
                    <WithError state={ this.state } field='password'>
                      { error => (
                        <Error data-aid={ dataAids.MEMBERSHIP_PASS_RESET_ERR_REND }>
                          { staticContent[error] }
                        </Error>
                      ) }
                    </WithError>
                  </Block>
                  <Block style={ styles.marginBottom }>
                    <Input
                      tag='input'
                      type='password'
                      name='confirmPassword'
                      autocomplete='new-password'
                      onChange={ this.onChange }
                      placeholder={ staticContent.confirmPassword }
                      aria-label={ staticContent.confirmPassword }
                      data-aid={ dataAids.MEMBERSHIP_PASS_RESET_CONFIRM_PASS }
                      value={ confirmPassword }
                    />
                    <WithError state={ this.state } field='confirmPassword'>
                      { error => (
                        <Error data-aid={ dataAids.MEMBERSHIP_PASS_RESET_ERR_REND }>
                          { staticContent[error] }
                        </Error>
                      ) }
                    </WithError>
                  </Block>
                  <Input type='hidden' name='contactId' value={ contactId } />
                  <Input type='hidden' name='redirect' value={ redirect } />
                  <Input type='hidden' name='app' value={ app } />
                  <Input type='hidden' name='token' value={ token } />
                  <Input type='hidden' name='email' value={ email } />
                  <Block style={ styles.formButtonBlock }>
                    <Button.Primary
                      tag='button'
                      type='submit'
                      data-aid={ dataAids.MEMBERSHIP_PASS_RESET_SUBMIT }
                      disabled={ busy }
                      style={ styles.marginBottom }
                      state={ busy ? 'disabled' : undefined } // eslint-disable-line no-undefined
                    >
                      { staticContent.resetPasswordSubmit }
                    </Button.Primary>
                  </Block>
                </UX2.Group.Form>
              </React.Fragment>
            ) }
            { codeExpired && (
              <Error
                style={ styles.marginBottom }
                data-aid={ dataAids.MEMBERSHIP_PASS_EXPIRED_MESSAGE_REND }
              >
                { staticContent.expiredResetLink }
              </Error>
            ) }
            <WithError state={ this.state } field='form'>
              { error => (
                <Error data-aid={ dataAids.MEMBERSHIP_PASS_RESET_ERR_REND }>
                  { staticContent[error] }
                </Error>
              ) }
            </WithError>
          </Cell>
        </Grid>
      </Container>
    );
  }
}

ResetPasswordForm.propTypes = {
  staticContent: PropTypes.object,
  env: PropTypes.string,
  ventureId: PropTypes.string
};

export default ResetPasswordForm;
